module.exports = __webpack_public_path__ + "media/question1_au.21f32482.mp3";